import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import config from "../../config";
import API from "../../axios/API";
import SaveTogglePopUp from "../Account/AccountCreate/SaveTogglePopUp";
import WallpaperModal from "./WallpaperModal";

const Wallpaper = () => {
  const [media, setMedia] = useState(null);
  const [scheduleType, setScheduleType] = useState("Limited");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [priority, setPriority] = useState(1);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);

  useEffect(() => {
    if (scheduleType === "Infinite") {
      const maxDate = new Date(9999, 10, 31);
      setEndDate(maxDate.toISOString().slice(0, 16));
    }

    if (!isSubmitted) {
      setErrors((prevErrors) => ({ ...prevErrors, startDate: "" }));
    }
  }, [scheduleType, isSubmitted]);

  useEffect(() => {
    if (isSubmitted) {
      validateForm();
    }
  }, [media, scheduleType, startDate, endDate, priority, isSubmitted]);
  //}, [image, scheduleType, startDate, endDate, priority, isSubmitted]);

  //const handleImageChange = (e) => {
    //setImage(e.target.files[0]);
    //if (e.target.files[0]) {
      //setErrors((prevErrors) => ({ ...prevErrors, image: "" }));
    //}
  //};
  const handleMediaChange = (e) => {
    const file = e.target.files[0];
    setMedia(file);

    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif", "video/mp4"];
      if (!validTypes.includes(file.type)) {
        setErrors((prevErrors) => ({ ...prevErrors, media: "Invalid file type."}));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, media: "" }));
      }
    }
  };

  const handleScheduleTypeChange = (e) => {
    const newScheduleType = e.target.value;
    setScheduleType(newScheduleType);
    if (newScheduleType === "Limited") {
      setEndDate("");
    }
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    if (e.target.value) {
      setErrors((prevErrors) => ({ ...prevErrors, startDate: "" }));
    }
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    if (e.target.value) {
      setErrors((prevErrors) => ({ ...prevErrors, endDate: "" }));
    }
  };

  const handlePriorityChange = (e) => {
    setPriority(Number(e.target.value));
    if (e.target.value >= 1 && e.target.value <= 10) {
      setErrors((prevErrors) => ({ ...prevErrors, priority: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    //if (!image) {
      //newErrors.image = "Image is required";
    //}
    if (!media) {
      newErrors.media = "Media file image or video is required.";
    }

    if (scheduleType === "Limited") {
      if (!startDate) {
        newErrors.startDate = "Start date and time are required";
      }
      if (!endDate) {
        newErrors.endDate = "End date and time are required";
      } else if (new Date(endDate) <= new Date(startDate)) {
        newErrors.endDate =
          "End date and time must be after start date and time";
      }
    } else if (scheduleType === "Infinite") {
      if (!startDate) {
        newErrors.startDate =
          "Start date and time are required for Infinite scheduling";
      }
    }

    if (priority < 1 || priority > 10) {
      newErrors.priority = "Priority must be between 1 and 10";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (validateForm()) {
      try {
        const formData = new FormData();
        formData.append(
          "info",
          JSON.stringify({
            startDate: startDate,
            endDate: endDate,
            seqPriority: priority,
          })
        );
        formData.append("file", media);
        const response = await API.post(
          `${config.baseUrl}/wallpaper/api/upload`,
          //"http://localhost:9105/wallpaper/api/upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          console.log("Form Submitted Successfully");
          setMedia(null);
          setScheduleType("Limited");
          setStartDate("");
          setEndDate("");
          setPriority(1);
          setErrors({});
          setIsSubmitted(false);
          setShowSaveModal(true);
        } else {
          console.error("Submission Error:", response.status);
          console.error(response.data);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  return (
    <>
      <WallpaperModal
        showSaveToggleValues={showSaveModal}
        setShowSaveModal={setShowSaveModal}
      />
      <form className="container mt-4" onSubmit={handleSubmit}>
        <Accordion
          defaultActiveKey="0"
          className="demo-accordion accordionjs m-0"
        >
          <Accordion.Item
            eventKey="0"
            className="acc_section mb-4"
            style={{
              borderLeft: "none",
              borderRight: "none",
              borderTop: "none",
              borderBottom: "0.5px solid #d1d4d9",
              borderRadius: "6px",
            }}
          >
            <Accordion.Header
              className="acc_head hoverClass"
              style={{
                fontWeight: "500",
                border: "1px solid #d1d4d9",
                borderRadius: "6px",
              }}
            >
              Wallpaper
            </Accordion.Header>

            <Accordion.Body>
              <div className="row mb-3">
                <div className="col-md-4 col-sm-5 d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ fontWeight: "normal" }}
                  >
                    Upload Media 
                  </label>
                  <span className="text-danger">*</span>
                </div>
                <div className="col-md-8">
                  <input
                    type="file"
                    id="media "
                    accept="image/*,video/mp4"
                    onChange={handleMediaChange}
                    className="form-control"
                  />
                  {errors.media && (
                    <div className="text-danger mt-1">{errors.media}</div>
                  )}
                </div>
              </div> 

              <div className="row mb-3">
                <div className="col-md-4 col-sm-5 d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ fontWeight: "normal" }}
                  >
                    Scheduling
                  </label>
                  <span className="text-danger">*</span>
                </div>
                <div className="col-md-8">
                  <select
                    id="scheduleType"
                    value={scheduleType}
                    onChange={handleScheduleTypeChange}
                    className="form-control"
                  >
                    <option value="Limited">Limited</option>
                    <option value="Infinite">Infinite</option>
                  </select>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4 col-sm-5 d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ fontWeight: "normal" }}
                  >
                    Start Date and Time
                  </label>
                  <span className="text-danger">*</span>
                </div>
                <div className="col-md-8">
                  <input
                    type="datetime-local"
                    id="startDate"
                    value={startDate}
                    onChange={handleStartDateChange}
                    className="form-control"
                  />
                  {errors.startDate && (
                    <div className="text-danger mt-1">{errors.startDate}</div>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4 col-sm-5 d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ fontWeight: "normal" }}
                  >
                    End Date and Time
                  </label>
                  <span className="text-danger">*</span>
                </div>
                <div className="col-md-8">
                  <input
                    type="datetime-local"
                    id="endDate"
                    value={endDate}
                    onChange={handleEndDateChange}
                    disabled={scheduleType === "Infinite"}
                    className="form-control"
                  />
                  {errors.endDate && (
                    <div className="text-danger mt-1">{errors.endDate}</div>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-4 col-sm-5 d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ fontWeight: "normal" }}
                  >
                    Priority (1 to 10)
                  </label>
                  <span className="text-danger">*</span>
                </div>
                <div className="col-md-8">
                  <input
                    type="number"
                    id="priority"
                    min="1"
                    max="10"
                    value={priority}
                    onChange={handlePriorityChange}
                    onBlur={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (value < 1) {
                        setPriority(1);
                      } else if (value > 10) {
                        setPriority(10);
                      } else {
                        setPriority(value);
                      }
                    }}
                    className="form-control"
                  />
                  {errors.priority && (
                    <div className="text-danger mt-1">{errors.priority}</div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-outline-success btn-save-next float-end mt-4"
                >
                  Save
                </button>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </form>
    </>
  );
};

export default Wallpaper;
